import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import styled from 'styled-components';
import Image from './Image';
import ImageContainer, { imageContainerMixin } from './ImageContainer';
import { getPx } from '../helpers/common';
import { getPreviewUrl } from './helpers';
import { useMeasure } from '../hooks';
import { IMAGE_BLUR_RADIUS } from './constants';
const StyledPreviewImage = styled.img`
  object-fit: ${({
  $fit = 'cover'
}) => $fit};
  -webkit-filter: blur(${getPx(IMAGE_BLUR_RADIUS)});
  filter: blur(${getPx(IMAGE_BLUR_RADIUS)});
  ${imageContainerMixin}
`;
const ImageResizeAware = ({
  ready = true,
  preview = true,
  backgroundColor,
  className,
  fit = 'cover',
  ...props
}) => {
  const {
    setRef,
    bounds
  } = useMeasure();
  return /*#__PURE__*/React.createElement(ImageContainer, {
    ref: setRef,
    className: className,
    backgroundColor: backgroundColor
  }, bounds.width && bounds.height && ready ?
  /*#__PURE__*/
  // render proper image when size is defined
  React.createElement(Image, _extends({
    preview: preview,
    width: bounds.width,
    height: bounds.height,
    fit: fit
  }, props)) :
  // render blurry preview image or no preview at all if size is not measured yet
  preview ? /*#__PURE__*/React.createElement(StyledPreviewImage, {
    src: getPreviewUrl(props),
    alt: props.alt,
    $fit: fit
  }) : null);
};
export default ImageResizeAware;